import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useRubiksTheme } from '../theme';
import { FlexBox } from './flexbox';
export const ScrollBox = React.forwardRef((props, outerRef) => {
    const { shadowType, scrollbarGutter, ...boxProps } = props;
    const [scrollShadow, setScrollShadow] = React.useState('none');
    const ref = React.useRef(null);
    const { theme } = useRubiksTheme();
    React.useEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        const scroll = () => {
            const tolerance = 2;
            if (el.scrollHeight > el.clientHeight) {
                if (el.scrollTop === 0) {
                    setScrollShadow('bottom');
                }
                else if (Math.round(el.scrollTop + el.clientHeight) >=
                    el.scrollHeight - tolerance) {
                    setScrollShadow('top');
                }
                else {
                    setScrollShadow('both');
                }
            }
            else {
                setScrollShadow('none');
            }
        };
        scroll();
        el.addEventListener('scroll', scroll);
        const observer = new ResizeObserver(scroll);
        observer.observe(el);
        return () => {
            el.removeEventListener('scroll', scroll);
            observer.disconnect();
        };
    }, []);
    return (_jsx(FlexBox, { ref: outerRef, "data-role": "scroll-box", stretch: true, position: "relative", maxWidth: "100%", height: "100%", minHeight: 0, sx: {
            ':before': {
                content: '""',
                opacity: scrollShadow === 'both' || scrollShadow === 'top'
                    ? 1
                    : 0,
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: 4,
                background: `linear-gradient(180deg, ${theme.palette.divider}, rgba(255, 255, 255, 0))`,
                transition: 'opacity 0.1s',
                pointerEvents: 'none',
                zIndex: 1
            },
            ':after': {
                content: '""',
                opacity: scrollShadow === 'both' || scrollShadow === 'bottom'
                    ? 1
                    : 0,
                position: 'absolute',
                left: 0,
                bottom: 0,
                width: '100%',
                height: shadowType === 'small' ? 4 : 40,
                background: shadowType === 'small'
                    ? `linear-gradient(180deg, rgba(255, 255, 255, 0), ${theme.palette.divider})`
                    : `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${theme.palette.background.paper} 100%)`,
                transition: 'opacity 0.1s',
                pointerEvents: 'none',
                zIndex: 1
            }
        }, children: _jsx(FlexBox, { "data-role": "scroll-box-inner", stretch: true, stack: true, overflow: "auto", 
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
            ref: ref, width: "100%", sx: { scrollbarGutter }, ...boxProps }) }));
});
